<h2>Property document details:</h2>

<ul *ngIf="doc != null">
    <li><span>Document Name:</span><span class="value-span">{{doc.title}}</span></li>
    <li><span>Document Date:</span><span class="value-span">{{doc.documentdate * 1000 | date:'dd/MM/yyyy'}}</span></li>
    <li><span>QR Code:</span><span class="value-span">{{doc.documentqrcode}}</span></li>
    <li><span>Notary Name:</span><span class="value-span">{{doc.notaryname}}</span></li>
    <li><span>Notary License No:</span><span class="value-span">{{doc.notarylicno}}</span></li>
    <li><span>Notarization Date:</span><span class="value-span" *ngIf="doc.notarizationdate!=0" >{{doc.notarizationdate * 1000 | date:'dd/MM/yyyy'}}</span></li>
    <li><span>Notary Registration Number:</span><span class="value-span">{{doc.docregno}}</span></li>

</ul>
